import type { Decimal } from '@insio/decimal';

/** Fraction-digit bounds for exchange rates — deliberately wider than currency precision. */
const MIN_FRACTION_DIGITS = 2;
const MAX_FRACTION_DIGITS = 4;

/**
 * Formats an exchange rate for display, locale-aware, with 2–4 decimals.
 * Returns an empty string for a nil rate.
 */
export function formatExchangeRate(rate: Decimal | null | undefined, locale: string): string {
  if (rate == null) return '';
  return rate.toNumber().toLocaleString(locale, {
    minimumFractionDigits: MIN_FRACTION_DIGITS,
    maximumFractionDigits: MAX_FRACTION_DIGITS
  });
}
